export default {"src":"/uk/_next/static/media/folderIcon.87b6b515.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};